import gql from 'graphql-tag';

export const getHighlight = gql`
	query getHighlight($id: ID!) {
		getHighlight(id: $id) {
			id
			available
			availableTime
			type
			publishTime
			videoAssets {
				items {
					format
					url
				}
			}
			gameId
			game {
				title
				sport
				status
			}
			periods {
				items {
					id
					playId
					startPosition
					endPosition
					endpoint
					endpoints {
						url
						format
					}
					endScore
					shortText
					source {
						type
						channelId
						startTime
						endTime
						gameId
					}
					startGameTime {
						segment
						segmentId
						position
					}
					title
					type
					description
					team {
						id
						name
						logoUrl
					}
					excitementScore
					excitementThreshold
				}
			}
			drm
			sources {
				drmProvider
				contentRef
				configAlias
				propositionContentId
				protection
				transport
				providerVariantId
			}
		}
	}
`;

export const listHighlights = gql`
	query listHighlights($sortDirection: SortDirection, $limit: Int, $nextToken: String) {
		listHighlights(sortDirection: $sortDirection, limit: $limit, nextToken: $nextToken) {
			items {
				id
				available
				availableTime
				type
				gameId
				game {
					title
				}
				periods {
					items {
						title
					}
				}
				publishTime
			}
			nextToken
		}
	}
`;
